
/* ============================== src/components/discussion/CommentActions.jsx ============================== */
// src/components/discussion/CommentActions.jsx
import { useDiscussion } from "./context";

export default function CommentActions({ comment }) {
  const { policy, setEditingId, setEditText, onReply, togglePin, onDelete } =
    useDiscussion();

  return (
    <div className="cm-actions">
      <button
        className="link"
        onClick={(e) => {
          e.stopPropagation();
          onReply(comment.id);
        }}
      >
        Ответить
      </button>
      {policy.canEdit(comment) && (
        <button
          className="link"
          onClick={(e) => {
            e.stopPropagation();
            setEditingId(comment.id);
            setEditText(comment.text);
          }}
        >
          Редактировать
        </button>
      )}
      {policy.canPin(comment) && (
        <button
          className="link"
          onClick={(e) => {
            e.stopPropagation();
            togglePin(comment);
          }}
        >
          {comment.pinned ? "Открепить" : "Закрепить"}
        </button>
      )}
      {policy.canDelete(comment) && (
        <button
          className="link red-link"
          onClick={(e) => {
            e.stopPropagation();
            onDelete(comment);
          }}
        >
          Удалить
        </button>
      )}
    </div>
  );
}
